import {
  buildStudentSearchQuery,
  EMPTY_STUDENT_FILTERS,
} from "@/features/students/shared/studentFilters";
import type { SearchQueryRequest } from "@/openapi/generated";
import type { MakeupRequestFiltersState } from "./makeupRequestFilters";

export function buildMakeupStudentNameSearchQuery(
  quickFirstName: string,
  quickLastName: string,
  filters: MakeupRequestFiltersState,
): SearchQueryRequest | null {
  return buildStudentSearchQuery(
    quickFirstName,
    {
      ...EMPTY_STUDENT_FILTERS,
      firstName: filters.firstName,
      lastName: filters.lastName,
    },
    quickLastName,
  );
}

export function hasMakeupStudentNameSearch(
  quickFirstName: string,
  quickLastName: string,
  filters: MakeupRequestFiltersState,
): boolean {
  return buildMakeupStudentNameSearchQuery(
    quickFirstName,
    quickLastName,
    filters,
  ) != null;
}
